var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.mounted
    ? _c("div", { staticClass: "sections" }, [
        _c(
          "section",
          [
            _c("RadioGroup", {
              attrs: { options: _vm.options },
              on: { input: _vm.yesNoChanged },
              model: {
                value: _vm.yesNo,
                callback: function($$v) {
                  _vm.yesNo = $$v
                },
                expression: "yesNo"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "section",
          [
            _c("h3", [
              _vm._v("Folgende Tätigkeiten hast du bereits eingegeben:")
            ]),
            _vm._v(" "),
            _c("Functions", {
              ref: "functions",
              attrs: {
                "with-edit-button": _vm.yesNo === true || !_vm.hasFunctions
              },
              on: { input: _vm.emitChangeEvent },
              model: {
                value: _vm.functions,
                callback: function($$v) {
                  _vm.functions = $$v
                },
                expression: "functions"
              }
            })
          ],
          1
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }